module.exports = __webpack_public_path__ + "static/media/visuarisk.ee32a94a.jpg";